export default __webpack_public_path__ + "static/media/trener6.1df0c4a6.png";